import {IModalService} from "angular-ui-bootstrap";
import {LeagueInviteController} from "./LeagueInviteController";

export class LeagueInviteService {

    public static id = "leagueInviteService";

    /** @ngInject */
    public constructor(private $uibModal: IModalService) {

    }

    public open(league: any) {
        var options = {
            templateUrl: "app/game/partials/leagues/invite/LeagueInviteTemplate.html",
            size: "lg",
            controllerAs: "ctrl",
            controller: LeagueInviteController,
            resolve: {
                league: () => league
            }
        };
        const instance = this.$uibModal.open(options);
        return instance.result;
    }
}